import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Debt, DebtService } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { requiredValidator } from '../../validators';

@Component({
  selector: 'app-escalate-legal-review-modal',
  templateUrl: './escalate-legal-review-modal.component.html',
})
export class EscalateLegalReviewModalComponent {
  @Input() debt: Debt;
  @Output() onUpdated = new EventEmitter();

  active = false;
  form = new FormGroup({
    comments: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(10000),
    ]),
  });

  constructor(private debtService: DebtService) {
  }

  open() {
    this.active = true;
  }

  close() {
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.debtService
        .update({
          id: this.debt.id,
          follow_up: new Date().toISOString(),
          notes: [{
            contents: `Case escalated to legal review by client.\n\nAdditional comments:\n${this.form.value.comments}`,
          }],
        }).subscribe(() => this.onUpdated.emit());
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/debts/escalate-legal-review-modal.component.ts